/* eslint-disable */

import React, { useCallback, useMemo, useState, useRef, useEffect  } from 'react'
import { withStyles } from '@aura/components/styles'
import { Box, Button,Container, Grid, Link, Typography, Radio } from '@aura/components'
import { useAuraThemeSwitcher } from '@aura/components/themes'
import { Trans, useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import RegistrationContainer from '../../../../components/new-registration-container'
import { deviceTypes, downloadLink, mobileDeviceTypes } from './constants/device-type'
import providerType from './constants/provider-type'
import styles from './styles'
import QRCode from 'qrcode'


const QRCodeCanvas = ({ url, size = 200 }) => {
    const canvasRef = useRef(null)
    
    useEffect(() => {
        if (canvasRef.current && url) {
            QRCode.toCanvas(
                canvasRef.current,
                url,
                {
                    width: size,
                    margin: 2,
                    color: {
                        dark: '#000000',
                        light: '#FFFFFF'
                    }
                },
                (error) => {
                    if (error) console.error(error)
                }
            )
        }
    }, [url, size])
    
    return <canvas ref={canvasRef} />
}
const Component = ({
    appName,
    classes,
    onBack,
    onFinish,
    onNext,
    provider,
    title,
    verbiage
}) => {
    const { theme } = useAuraThemeSwitcher()
        const icons = {
            'dark': {
                android : '/img/mfa/dark-android.svg?url',
               iphone: '/img/mfa/dark-iphone.svg?url'
            },
            'light': {
               android : '/img/mfa/light-android.svg?url',
               iphone: '/img/mfa/light-iphone.svg?url'
            }
        }
    const { t: translate } = useTranslation()
    const stepVerbiage = translate('authenticators.verbiage01')
    
    const [deviceType, setDeviceType] = useState(deviceTypes.IPHONE)
    const [downloadURL, setDownloadURL] = useState(
        downloadLink[provider]?.[deviceTypes.IPHONE] || ''
    )
  

    const handleTypeChange = useCallback((e, text) => {
        setDeviceType(text)
        setDownloadURL(downloadLink[provider]?.[text] || '')
    }, [provider])

  

    const footerContent = useMemo(() => {
        const footerButtons = [
            {
                className: classes.backButton,
                disabled: false,
                label: translate('back'),
                onClick: onBack,
                variant: 'text'
            },
            {
                className: `${classes.nextButton} ${!deviceType ? classes.nextButtonDisabled : ''}`,
                disabled: !deviceType,
                label: translate('next'),
                onClick: onNext
            }
        ]
        
        return (
            <Grid className={classes.buttonContainer}>
                {footerButtons.map((button, index) => (
                    <Button
                        key={`footer-button-${index}`}
                        className={button.className}
                        disabled={button.disabled}
                        onClick={button.onClick}
                        variant={button.variant}
                    >
                        {button.label}
                    </Button>
                ))}
            </Grid>
        )
    }, [classes.buttonContainer, classes.backButton, classes.nextButton, classes.nextButtonDisabled, deviceType, translate, onBack, onNext])
    
const mainContent = useMemo(() => (
    <>
    <div className={classes.introText}>
                <p className={classes.subTitle}>{stepVerbiage}</p>
            </div>
            <Container>
                <div className={''}>
                    <Grid className={''} item md={12} xs={12}>
                        

                                {Object.keys(mobileDeviceTypes).map((type, idx) => (
                                    <Box
                                key={idx}
                                className={`${classes.accountRecoveryOption} 
                                        ${deviceType === type && classes.selectedCardItem}`
                                }

                                onClick={() => handleTypeChange(null, type)}
                            >
                                <Box className={classes.accountRecoveryInfo}>
                                    <Box component='img' src={icons[theme.palette.mode][type]} alt={type} />
                                <p className={`${classes.iconDesc}`}>{mobileDeviceTypes[type]}</p>
                                </Box>
                                <Radio checked={deviceType === type} className={classes.radio} />
                            </Box>                                    
                                ))}
                    </Grid>
                </div>
            <Box className={classes.footerContainer}>
                <Container className={classes.firstColumn}>
            <Typography className={classes.verbiage}>
                {translate('deviceTypeNew.verbiage1', {appName: appName})} <Link className={classes.link} underline='always' href={downloadURL} target="_blank" rel="noopener noreferrer">{translate('deviceTypeNew.verbiage2')} {deviceType === deviceTypes.IPHONE ? 'App Store' : 'Google Play' }</Link> <Trans>{translate('deviceTypeNew.verbiage3', {appName: appName, deviceType: deviceType === deviceTypes.IPHONE ? 'iOS' : 'Android'})}</Trans>
            </Typography>
            <p className={`${classes.subTitle} ${classes.helpText}`}>{translate('registrationFlow.helpText')}</p>
            </Container>
            <Container className={classes.setupIcon}><QRCodeCanvas  url={downloadURL} size={100} /></Container>
           
            </Box>
            </Container>
            {/* <div className={classes.helpText}>
                
            </div> */}
            </>
), [ handleTypeChange, classes, translate, appName, downloadURL, deviceType, mobileDeviceTypes])
    return (
        <RegistrationContainer {...{ footerActions: footerContent, mainContent, title: translate(`authenticatorOptions.${title}`) }}>
            
        </RegistrationContainer>
    )
}

Component.displayName = 'DeviceType'

Component.defaultProps = {
    provider: providerType.OKTA
}

Component.propTypes = {
    appName: PropTypes.string,
    classes: PropTypes.shape({
        button: PropTypes.object,
        buttonContainer: PropTypes.object,
        cancelButton: PropTypes.object,
        loader: PropTypes.object,
        nextButton: PropTypes.object,
        nextButtonDisabled: PropTypes.object,
        root: PropTypes.object
    }),
    onBack: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    provider: PropTypes.string.isRequired,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(Component, styles)
